// extracted by mini-css-extract-plugin
export default {"header":"styles_header__-DYpM","table":"styles_table__Q+PFb"};